module.exports = __webpack_public_path__ + "img/Vector.8330dc62.svg";